// A Solid resource has answered: an error, or a value. The error is read first: `latest` throws on an errored resource,
// so `latest !== undefined || error` throws instead of saying "settled" (DESIGN-LOG §74h: a 502 on one list stopped the
// Workflow summary, and the setup screen's skeleton never resolved).
export const settled = (resource: { readonly error: unknown; readonly latest: unknown }) => !!resource.error || resource.latest !== undefined
